export default "__VITE_ASSET__af283c5d__"